var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"bottom-content",style:(`--primary-color:${_vm.primaryColor}`)},[_vm._t("default",function(){return [_c('Link',{attrs:{"href":_vm.href,"primary-color":_vm.primaryColor}},[_vm._v("\n      "+_vm._s(_vm.text)+"\n    ")])]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }